module.exports = __webpack_public_path__ + "img/09.165bdad6.png";